<template>
  <!-- 票据审核 弹窗 -->
  <section class="bill_examine">
    <!--审核界面-->

    <el-dialog :title="step" :visible="examineFormVisble" width="622px"
      @update:visible="v=>$emit('update:examineFormVisble',v)">
      <div v-if="isExamine">
        <el-form
          :model="form"
          label-width="88px"
          :rules="rules"
          style="margin-top:16px"
          ref="cancleForm"
        >
          <el-form-item label="审核意见：" style="width:300px;">
            <el-select
              placeholder="请选择"
              v-model="form.option"
              style="background:#fff"
              @click="changeOption(option)"
            >
              <el-option
                v-for="item in statusaoptions"
                :key="item.index"
                :value="item.Id"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注：" label-width="88px">
            <el-input type="textarea" v-model="form.desc" :rows="3"></el-input>
          </el-form-item>
        </el-form>
        <div class="examine_footer">
          <p @click="billSubmit('form')">确定</p>
          <p @click="$emit('update:examineFormVisble',false)">取消</p>
        </div>
      </div>
      <!-- 审核成功 -->
      <div class="succ_exam" v-show="isSucc">
        <!-- 审核成功提示 -->
        <div class="succ_tips">
          <img src="../../assets/img/aicon15_03.jpg" alt>
          <p>审核成功~</p>
        </div>
        <div class="examine_footer success">
          <p @click="change">确定</p>
          <i></i>
        </div>
      </div>
      <!-- 审核失败 -->
      <div class="succ_exam" v-show="isFail">
        <!-- 审核成功提示 -->
        <div class="succ_tips">
          <img src="../../assets/img/aicon15_06.jpg" alt>
          <p>审核失败~</p>
        </div>
        <div class="examine_footer success">
          <p @click="$emit('update:examineFormVisble',false)">确定</p>
          <i></i>
        </div>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import { shenhecoupon } from "../../api/api";
export default {
  props: ["examineFormVisble", "shenid"],
  data() {
    return {
      isExamine: true,
      isSucc: false,
      isFail: false,
      form: { desc: "", option: "" },
      step: "审核",
      // option:"",
      list: [{ index: 1, name: "同意" }, { index: 2, name: "拒绝" }],
      rules: {
        option: [{ required: false, trigger: "change" }],
        status: 0
      },
      statusaoptions: ""
    };
  },
  methods: {
    billSubmit(formName) {
      if (this.form.option == "同意") {
        this.isExamine = false;
        this.isSucc = true;
        this.step = "审核成功";
      } else {
        this.isExamine = false;
        this.isFail = true;
        this.step = "审核失败";
      }
    },
    change() {
      let shenid = this.$cookie.get("shenid");
      let operatorId = this.$cookie.get("OperatorId");
      var addParams = {
        id: shenid,
        remark: this.form.desc,
        operatorId: operatorId,
        status: ""
      };
      shenhecoupon(addParams).then(data => {
        // let newdata = data.ResultObj;
        this.$emit("update:examineFormVisble", false);
      });
    }
  },
  mounted() {
    let nesstatusoptions = this.$cookie.get("statusoptions");
    this.statusaoptions = nesstatusoptions;
  },
};
</script>

<style scoped>
.add_bill_examine .examine_footer.success {
  text-align: center;
  padding-left: 0;
  margin-top: 30px;
}
.el-col-24 {
  height: 55px;
  line-height: 55px;
  border-bottom: 1px solid #eee;
  margin: 0 0 20px 0;
}
/* 审核 */
.el-col-24 p {
  width: 120px;
  height: 55px;
 
  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin: 0;
  line-height: 55px;
}
.add_bill_examine .examine_footer {
  height: 40px;
  margin: 50px auto 28px;
  padding-left: 88px;
}
.add_bill_examine .examine_footer p {
  display: inline-block;
  width: 85px;
  height: 38px;
  background-color: #F56C6C;
  border-radius: 3px;
  cursor: pointer;
  line-height: 38px;
  text-align: center;
  color: #fff;
}
.add_bill_examine .examine_footer p:last-child {
  border: solid 1px #F56C6C;
  background-color: #fff;
  color: #F56C6C;
  margin-left: 10px;
}
/* 审核成功提示 */
.succ_tips {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  margin-top: 30px;
}
.succ_tips p {
  font-size: 20px;
  font-weight: normal;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// billExamine.vue?9b14ed70